<script setup>
import LHeader from "@/Layouts/Parts/LHeader.vue"
import LFooter from "@/Layouts/Parts/LFooter.vue"
import GlobalNotifications from "@/Components/GlobalNotifications.vue";
import LSubHeader from "@/Layouts/Parts/LSubHeader.vue";
import LNewSubHeader from "@/Layouts/Parts/LNewSubHeader.vue";

defineProps({
    cart: {
        type: Boolean,
        default: true
    },
    bgColor: {
        type: String,
        default: "bg-white"
    },
    switchCategoryMenu: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <v-app>
        <l-header :cart="cart"/>
        <l-new-sub-header v-if="switchCategoryMenu"></l-new-sub-header>
        <l-sub-header v-else></l-sub-header>
        <v-main style="--v-layout-top: 110px" :class="{[bgColor]: true}">
            <slot/>
        </v-main>
        <l-footer/>

        <GlobalNotifications />
    </v-app>
</template>